<template>
  <v-footer class="footer">
        <v-layout justify-center row wrap class="footer">
          <v-flex  py-3 text-xs-center xs12>

            <center>
            <img src="img/Logo_PUTI.png" alt="" style='max-width: 50px;max-height: 50px;margin-right: 30px'>
            <img src="img/logo_tsm.png" alt="" style='max-width: 50px;max-height: 50px;margin-right: 30px'>
          </center>
         
        </ul>
        <div class="copyright text-center" style="color: white">
        &copy; Created In 2021
      </div>
          </v-flex>
        </v-layout>
      </v-footer>
<!--   <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li style="padding-top: 5px">
            <img src="img/logo_yayasan_zheng_dao.png" alt="" style='max-width: 50px;max-height: 50px;margin-right: 30px'>
            <img src="img/Logo_PUTI.png" alt="" style='max-width: 50px;max-height: 50px;margin-right: 30px'>
            <img src="img/logo_tsm.png" alt="" style='max-width: 50px;max-height: 50px;margin-right: 30px'>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center" style="color: white">
        &copy; Created In 2021
      </div>
    </div>
  </footer> -->
</template>
<script>
  export default {}

</script>
<style>
nav li{
  list-style-type:none;
}
</style>
